import { SegmentDto } from 'src/store/segments/segment';
import { ArrayUtils } from 'src/utils/array';
import { ApiError } from '../api-handler';
import { SegmentAction, SegmentTypes } from './segments.actions';

export type SegmentsState = Readonly<{
  segments: SegmentDto[];
  errors: Nullable<ApiError>;
}>;

const initialState: SegmentsState = {
  segments: [],
  errors: null
};

const segmentsReducer = (
  state: SegmentsState = initialState,
  action: SegmentAction
) => {
  switch (action.type) {
    case SegmentTypes.FetchAll:
      return { ...state, segments: action.segments };
    case SegmentTypes.Add:
      return { ...state, segments: [...state.segments, action.segment] };
    case SegmentTypes.Update:
      // eslint-disable-next-line no-case-declarations
      const { id, no, name, active, description, markLabel } = action.segment;
      return {
        ...state,
        segments: state.segments.map(segment =>
          segment.id === id
            ? { ...segment, no, name, active, description, markLabel }
            : segment
        )
      };
    case SegmentTypes.Delete:
      return {
        ...state,
        segment: null,
        segments: ArrayUtils.deleteFromListById(state.segments, action.segment)
      };
    case SegmentTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default segmentsReducer;
